var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    width: 43.426,
    height: 43.609,
    x: -10.346,
    y: -10.45
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5.66px)",
      clipPath: "url(#a)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffebe1",
    d: "M16.727 7.918c.13-.485.2-.984.207-1.486A5.575 5.575 0 0 0 13.51 1.29a5.55 5.55 0 0 0-4.248-.007 5.54 5.54 0 0 0-3.005 3.003 5.6 5.6 0 0 0-.423 2.127 5.8 5.8 0 0 0 .2 1.494 5.52 5.52 0 0 0-4.356 2.802 5.55 5.55 0 0 0-.13 5.19 5.56 5.56 0 0 0 4.211 3.03 5.53 5.53 0 0 0 4.864-1.78 7.18 7.18 0 0 1-2.378 4.698l3.126-.025 3.136-.028c-1.578-1.006-2.155-3.222-2.378-4.683a5.53 5.53 0 0 0 7.339.787 5.53 5.53 0 0 0 2.298-4.64 5.56 5.56 0 0 0-2.535-4.523 5.54 5.54 0 0 0-2.523-.868z",
    "data-figma-bg-blur-radius": 11.313
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    transform: "translate(10.346 10.45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.727 7.918c.13-.485.2-.984.207-1.486A5.575 5.575 0 0 0 13.51 1.29a5.55 5.55 0 0 0-4.248-.007 5.54 5.54 0 0 0-3.005 3.003 5.6 5.6 0 0 0-.423 2.127 5.8 5.8 0 0 0 .2 1.494 5.52 5.52 0 0 0-4.356 2.802 5.55 5.55 0 0 0-.13 5.19 5.56 5.56 0 0 0 4.211 3.03 5.53 5.53 0 0 0 4.864-1.78 7.18 7.18 0 0 1-2.378 4.698l3.126-.025 3.136-.028c-1.578-1.006-2.155-3.222-2.378-4.683a5.53 5.53 0 0 0 7.339.787 5.53 5.53 0 0 0 2.298-4.64 5.56 5.56 0 0 0-2.535-4.523 5.54 5.54 0 0 0-2.523-.868z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.6e9d72766b7dbf2835f05afa13903123.svg";
export { ForwardRef as ReactComponent };